import { IPoint } from "../../../../base/domain/drawing";
import { IPropertyPresentable, instanceOfIPropertyPresentable } from "../../../../base/domain/system/edit";

export interface ILocationPropertyPresentable {
  location(): IPropertyPresentable<IPoint>;
}

export function instanceOfILocationPropertyPresentable(instance: any): instance is ILocationPropertyPresentable {
  return instance
      && instance.location
      && instanceOfIPropertyPresentable<IPoint>(instance.location());
}
